<template>
    <!-- SideBar -->
        <div class="sidebar" @keyup.esc="handleCloseSidebar()" >
            <div class="sidebar__inner sidebar__shadow px-3">
                <div>
                    <span class="btn__fechar float-right p-1 mt-1" @click="handleCloseSidebar"><i class="fa fa-close"></i></span>
                </div>

                <div class="sidebar__body">
                    <!-- Busca de Comandas -->
                    <div class="top-bar">
                        <div :class="params_pdv.tipo_controle_cm_ms == 'CM' ? 'col-8-custom' : 'col-12 px-0'">
                            <div class="d-flex justify-content-center align-items-center">
                                <div class="col-md-12 col-12 p-0">
                                    <div class="float-left">
                                        <strong v-if="modoComanda" style="font-size:12px">Buscar Comanda</strong>
                                        <strong v-else style="font-size:12px">Buscar Mesa</strong>
                                    </div>
                                    <div class="float-right">
                                        <input-checkbox :label="'Buscar por comanda'" v-model="modoComanda" :value-checked="true" :value-unchecked="false" v-if="params_pdv.tipo_controle_cm_ms == 'MC'"></input-checkbox>
                                    </div>
                                </div>
                                <!-- <form-field v-model="codigo" col="12 p-0" type="text" label="Buscar Comanda"></form-field> -->
                            </div>
                            <div style="position: relative; z-index:10; background-color:white">
                                <div class="col-md-12 col-12 p-0">
                                    <div class="input-group ">
                                        <input ref="pesquisacomanda" v-model="codigo" style="font-size:17px" class="col-12 vd-input px-2 py-1" id="searchComanda" type="text" autocomplete="off"
                                        :placeholder="pesquisacomandaPlaceholder" @keyup.120.stop="modoComanda = !modoComanda" @keyup.enter=" () => modoComanda ? handleChosePedido() : handleChose()">
                                    </div>
                                    <div v-if="params_pdv.tipo_controle_cm_ms == 'MC'">
                                        <span v-if="modoComanda" class="text-secondary" style="font-size:12px">F9 - Alterar para mesa</span>
                                        <span v-else class="text-secondary" style="font-size:12px">F9 - Alterar para comanda</span>
                                    </div>
                                    <span v-if="params_pdv.tipo_controle_cm_ms == 'CM'" class="text-secondary" style="font-size:12px">ALT + N - Novo Pedido</span>
                                </div>
                            </div>
                        </div>
                        <div class="">
                            <button class="btn py-1" :class="params_pdv.tipo_controle_cm_ms == 'MC' ? 'mt-0' : 'mt-3'"
                                ref="newPed"
                                v-if="params_pdv.tipo_controle_cm_ms == 'CM'"
                                @click.stop="handleSetNewSale()"
                                :style="`background: ${params_pdv.colors.bg_top_bottom ? params_pdv.colors.bg_top_bottom : '#174b79'}; color: ${params_pdv.colors.fc_top_bottom ? params_pdv.colors.fc_top_bottom : 'white;'}; padding: 0 35px`"
                            >
                                <i class="fa fa-plus"></i> Novo Pedido
                            </button>
                        </div>

                    </div>

                    <!-- Listagem de Comandas -->
                    <div class="mt-2 col-md-12 row" v-if="modoComanda">
                        <button class=" p-0 my-1  col-md-10 mr-3" style="border: 2px solid black;  max-width:180px; background:transparent"  v-for="(comanda, index) in comandas" :key="index" @click="handleChosePedido(comanda.codpedv)" v-if="comanda.comanda">
                           <div class="px-2 py-2 text-left d-flex flex-column relative" style="border-bottom: 2px solid black">
                                <div class="comanda-mesa-square" v-if="comanda.mesa"><i class="fa fa-table mr-1"></i><span style="word-break:break-all">{{comanda.mesa}}</span></div>
                                <i class="def-title text-center  text-dark fa fa-solid fa-barcode" style="font-size:50px"></i>
                               <strong class="text-center">{{comanda.data | formatDataHora}}</strong>
                            </div>
                            <div class="border text-center text-danger" style="max-height:68px; max-width:200px">
                                <strong style="min-height:68px; font-size:30px">{{comanda.comanda}}</strong>
                            </div>
                        </button>
                    </div>
                    <!--LIstagem de Mesas-->
                    <div class="row mt-2" v-if="!modoComanda && !codigo">
                        <div class=" col-md-4 col-5 text-left my-1" v-for="(mesa, index) in listMesas" :key="index" style="padding: 0 15px !important">
                            <button class="d-flex flex-column text-left lista__mesas border border-secondary p-3 col-12" id="mesa" style="min-height:110px"
                                @click="handleChose(mesa.id)"
                                :style="mesa.pedidos.length > 0 ? 'background: #ededed !important': ''"
                            >
                                <div class="d-flex justify-content-between w-100">
                                    <strong class="col-12 row">{{ mesa.id }} | {{mesa.descricao}}</strong>
                                    <span v-if="!modoComanda && !codigo" :class="mesa.pedidos.length ? 'bg-danger' : ''" class="  translate-middle d-flex justify-content-center  bg-success border rounded-circle badge-mesa-st"
                                        style="z-index:9999;"></span>
                                </div>
                                <small>Obs: {{ mesa.obs }}</small>
                                <div class="d-flex">
                                    <small v-if="mesa.pedidos.length > 0"><strong >Pedidos</strong> {{mesa.pedidos.length}}</small>
                                    <small class="ml-2" v-if="mesa.pedidos.length > 0"><strong>{{listMesas[index].pedidos[0].data | formatDataHora}}</strong></small>
                                </div>
                            </button>
                        </div>

                    </div>
                    <div  class="lista__mesas  mt-2 cursor-pointer col-md-12 text-left border border-secondary"  v-for="(mesa, indice) in mesas" :key="indice" v-if="showDetails && !modoComanda">
                        <div class="row  px-3 py-2 px-0" id="mesa" >
                            <div class="col-md-10 col-5 ">
                                <div style="word-break:break-all;">
                                    <strong>Código: {{mesa.id}}</strong> |
                                    <strong>{{mesa.descricao}}</strong>
                                </div>
                                <div>
                                    <small>Pedidos Abertos: {{mesa.pedidos.length}}</small>
                                    <small>Observação: {{mesa.obs}}</small>
                                </div>

                            </div>
                            <div class="col-md-auto col-3 p-0 ">
                                <div class="d-flex align-items-center border border-dark p-2 " v-if="mesa.pedidos.length > 0">
                                    <strong>Ocupado</strong>
                                    <span class="bg-danger  border border-light rounded-circle badge-mesa-st ml-1 " style="width:10px; height: 10px; "></span>
                                </div>
                                <div class="d-flex align-items-center border border-dark p-2" v-else>
                                    <strong>Liberado</strong>
                                    <span class="bg-success  border border-light rounded-circle badge-mesa-st ml-1 " style="width:10px; height: 10px; "></span>
                                </div>
                            </div>
                            <div class="col-md-12 d-flex flex-wrap align-items-center" style="word-break:break-all;">
                                <button v-for="(ped, index) in mesa.pedidos" :key="index" :id="`ped${index}`" :ref="`ped${index}`"  style="line-height: 18px !important; background:#fff;" class=" btn px-3  btn-outline-custom border col-md-auto mx-1  my-1  align-items-center"
                                    @keyup.left="handleLeft(index)"
                                    @keyup.right="handleRight(index, mesa.id)"
                                    @click="handleChosePedido(ped.codpedv)"
                                    v-if="ped.stpedv != 'C' || ped.stpedv != 'F'"
                                >
                                    <div class="d-flex align-items-center p-0 m-0">
                                        <span class="bg-success d-flex  border border-light rounded-circle badge-mesa-st" style="width:10px; height: 10px; "></span>
                                        <span class="mx-1" v-if="!ped.comanda">{{ped.npedido}}</span>
                                        <div class="font-size:13px">
                                            <span v-if="ped.comanda"><strong class="text-danger ml-1">COMANDA: </strong>{{ped.comanda}}</span>
                                            <span v-else>{{ped.obspedido}}</span>
                                            <strong class="ml-1"> R$ {{ped.totmer | formatValue(2)}}</strong>
                                        </div>
                                    </div>
                                    <div class="p-0 m-0 text-left mt-0 pt-0" style="margin-left:20px!important">


                                        <small style="font-size:13px"><strong>Data: </strong>{{ped.data | formatDataHora}}</small>
                                    </div>
                                </button>
                                <button class="btn py-1"  :class="params_pdv.tipo_controle_cm_ms == 'MC' ? 'mt-0' : 'mt-3'"
                                    ref="newPed"
                                    v-if="(codigo && listMesas && codigo <= listMesas.length) || params_pdv.tipo_controle_cm_ms == 'CM' "
                                    @click.stop="handleSetNewSale()"
                                    @keyup.left="handleLeftNewPed()"
                                    :style="`background: ${params_pdv.colors.bg_top_bottom}; color: ${params_pdv.colors.fc_buttom}; padding: 0 35px; max-height:40px` "
                                >
                                    <i class="fa fa-plus"></i> Novo Pedido
                                </button>
                                <div class="text-right w-100" v-if="mesa.totmesa">
                                    <strong style="font-size:20px" class="mr-1">TOTAL R$ {{ mesa.totmesa| formatValue(2)}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                        <div v-if="mesas">
                            <div class="" style="" v-if="mesas.length <= 0 && !modoComanda && codigo">
                                <alert type="warning text-dark"  text="Mesa não cadastrada"/>
                            </div>
                        </div>
                        <div v-if="comandas && modoComanda">
                            <div class="" style="" v-if="comandas.length <=0 || comandas.length <=0">
                                <alert type="warning text-dark"  text="Não possui registros"/>
                                <span></span>

                            </div>
                        </div>
                </div>
            </div>
        </div>
</template>

<script>
import formField from './form-field.vue'
import { SysVars } from '../main'
import Trap from 'vue-focus-lock'
export default {
    components: { formField, Trap },
    props:{
        params_pdv: {
            type: Object,
            default: {}
        },
        listMesas: {
            type: Array,
            default: []
        },
        listComandas:{
            type: Array,
            default: []
        }
    },
    data() {
        return {
            showDetails: false,
            modoComanda: false,
            comandas: null,
            mesas: null,
            codigo: null,
            hasId: false,
            listaComandas: this.listComandas
        }
    },
    computed: {
        hasPedido(){
            let mesas = this.listMesas
            let idMesa = this.codigo
            let hasPedido = false
            mesas.find(mesa=>{
                if(mesa.pedidos){
                    if(mesa.id == idMesa){
                        if(mesa.pedidos.length > 0){
                            hasPedido = true
                        }
                    }
                }
            })

            return hasPedido
        },
        pesquisacomandaPlaceholder(){
            if(this.modoComanda){
                return 'Digite número da comanda'
            }
            if(!this.modoComanda){
                return 'Digite a mesa'
            }
        },
    },
    methods: {
        handleSetNewSale(){
            this.$emit('newSale', this.codigo)
        },
        handleChose(id){
            if(id){
                this.codigo = id
                this.loadMesas(this.codigo)
            }

            if(!this.hasPedido){
                this.$nextTick(function(){
                    this.$refs.newPed[0].focus()
                })
                    return;
            }

            this.$nextTick(function () {
                this.$refs.ped0[0].focus()
            })
        },
        handleLeftNewPed(){
            const index = this.mesas[0].pedidos.length;

            if(index <= 0){
                if(this.$refs.pesquisacomanda){
                    this.$nextTick(function (){
                        this.$refs.pesquisacomanda.focus()
                    })
                }
                return;
            }

            document.getElementById(`ped${index - 1}`).focus();

        },
        handleLeft(index){
            let indice = index-1
            if(indice < 0){
                if(this.$refs.pesquisacomanda){
                    this.$nextTick(function (){
                        this.$refs.pesquisacomanda.focus()
                    })
                }
                return;
            }
            document.getElementById(`ped${indice}`).focus()
        },
        handleRight(index, id){
            let indice = index + 1
            let indiceMesa = ''
            let self = this;

            this.mesas.find((mesa, index) =>{
                if(mesa.id == id)
                  return indiceMesa = index
            })

            if(indice >= this.mesas[indiceMesa].pedidos.length){
                this.$nextTick(()=>{
                    this.$refs.newPed[0].focus()
                })
                return;
            }
            document.getElementById(`ped${indice}`).focus();
        },
        handleChosePedido(id){
            this.$emit('chosePedidoMesa', id)
            if(!id){
                this.listaComandas.forEach(comanda =>{
                    if(comanda.comanda == this.codigo){
                        this.$emit('chosePedidoMesa', comanda.codpedv)
                    }
                })
            }
        },
        focusControl: function (event) {
            var thisIndex = jQuery(this.$el.querySelector('input')).index(SysVars.sFocusControl)
            var next = thisIndex + 1
            var obj = jQuery(SysVars.sFocusControl)
            for (var x = next; x < obj.length; x++) {
                if (jQuery(obj[x]).prop("tabindex") === 1 && !jQuery(obj[x]).is("disabled")) {
                    jQuery(obj[x]).focus()
                    break
                }
            }
        },
        loadMesas(numeroMesa){
            const mesas = this.listMesas.filter((mesa)=>{

                if(mesa.pedidos.length > 0 && !this.modoComanda){
                    let valor = 0
                    for (let i = 0; i < mesa.pedidos.length; i++) {
                        valor += mesa.pedidos[i].totmer
                    }
                    mesa.totmesa = valor
                }


                if(numeroMesa)
                     return mesa.id == numeroMesa || mesa.descricao == numeroMesa

                else if(this.params_pdv.tipo_controle_cm_ms == 'MC'){

                    this.comandas = []
                    this.listaComandas = []
                    this.listMesas.forEach( e =>{
                            e.pedidos.forEach( ped =>{
                                this.comandas.push(ped)
                                this.listaComandas.push(ped)
                            })
                    })
                } else
                    return mesa



            })
            let self = this;

            if(mesas.length > 0 ){
                this.hasId = false
                this.mesas = mesas
                return;
            }else{
                this.mesas = mesas
                this.hasId = true

            }
            this.showDetails = false

        }  ,
        loadComandas(codigo) {
            this.comandas= []
            const comandas = this.listaComandas.filter((comanda) => {
                if (codigo)
                    return comanda.comanda == codigo
                else
                    return comanda
            })
            this.comandas = comandas


        },
        handleCloseSidebar() {
            this.$emit('close')
        }
    },
    watch: {
        codigo(n, o) {
            o = ''
            n= ''
            this.showDetails = false
            if(this.modoComanda){
                this.loadComandas(this.codigo)
            }
            if(!this.modoComanda){
                let self = this;
                setInterval(() =>{
                    if(self.codigo){
                        self.showDetails = true
                    }
                    self.loadMesas(self.codigo)
                },200)

            }
        },
        modoComanda: {
            handler: function (before, afeter){
                if (this.modoComanda && this.params_pdv.tipo_controle_cm_ms == 'MC'){
                this.codigo = ''
                this.comandas = []
                this.listaComandas = []
                if(this.params_pdv.tipo_controle_cm_ms == 'MC'){
                    this.listMesas.forEach( e =>{
                            e.pedidos.forEach( ped =>{
                                this.comandas.push(ped)
                                this.listaComandas.push(ped)
                            })
                    })
                    return;
                }
                else{
                    this.comandas = {...this.listaComandas}
                }

                }
                if(!this.modoComanda){
                    this.codigo = ''
                    this.mesas = {...this.listMesas}
                }
            },
            immediate: true

        },

        // numeroPedido() {
        //     this.loadPedidos(this.numeroPedido)
        // }
    },
    created () {

       this.listMesas.forEach((e,indice)=>{
            if(!this.listMesas[indice].hasOwnProperty('pedidos')){
                this.listMesas[indice].pedidos = []
            }
        })

    },
    mounted(){
        this.comandas = []
         if((!this.params_pdv.listMesas || this.params_pdv.listMesas == null || this.params_pdv.listMesas.length <=0) || this.params_pdv.tipo_controle_cm_ms == 'CM'){
            this.modoComanda = true
            this.loadComandas();

        }

        if(!this.modoComanda && this.params_pdv.listMesas.length > 0){
            this.modoComanda = false
            this.loadMesas()
        }

        if(this.params_pdv.tipo_controle_cm_ms == 'MC'){
            this.modoComanda = false;

            setTimeout(()=>{
                this.modoComanda = false
            },10 )

            this.loadMesas();
            clearTimeout();
        }
        this.$nextTick( function (){
            this.$refs.pesquisacomanda.focus()
        })
        var self = this;



        window.addEventListener('keyup', function (event){
            if(event.altKey){
                if(event.keyCode == 78){
                    self.handleSetNewSale('newSale', this.codigo)
                }
            }
        })

    }
}
</script>

<style scoped>
    .comanda-mesa-square{
        border: 1px solid;
        max-width: 40%;
        text-align: center;
    }
    .top-bar{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .col-8-custom{
        width: 70%;
    }
    .btn-outline-custom:focus-within{
        background: #004489 !important;
        color:white;
        border: 1px solid #004489!important;
        box-shadow: 0 0 0 0 rgba(0,0,0,0),0 0 0 0 rgba(0,0,0,0) !important;
        border:none!important;
    }
    .lista__comandas{
        background: none;
        border:0;
        display: block;
        padding: 0;
    }
    .lista__mesas{
        background: none;
        border:0;
        display: block;
        padding: 0;
    }
    .sidebar {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        /* transform: translate3d(100%, 0, 0); */
        transition: all .35s;
        will-change: transform;
        z-index: 10000;
    }

    .sidebar__inner {
        display: flex;
        flex-direction: column;
        background-color: #fff;
        overflow: hidden;
        height: 100%;
        width: 50vw;
    }

    .sidebar__shadow {
        box-shadow: 0 0 32px 0 #a9aaac80;
    }

    @media (max-width: 768px) {
        .sidebar__inner {
            width: 90vw;
        }
    }

    .sidebar__footer {
        display: flex;
        align-items: center;
        background-color: #fff;
        padding: 10px 20px;
        flex: 0 0 78px;
    }

    .sidebar__body {
        padding: 0 1rem !important;
        overflow-y: auto;
        height: 100%;
    }

    #comanda {
        margin: .25rem 0;
        cursor: pointer;
    }

    .btn__fechar {
        color: #5a5858;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/sidebar-comandas.vue